import PropTypes from 'prop-types';
import React from 'react';

import Tabs from 'app/components/shared/Tabs';
import SearchBar from 'app/components/shared/SearchBar';
import ProgressBar from 'app/components/shared/ProgressBar';
import '../styles/AddTitle.scss';

class AddTitle extends React.PureComponent {
  componentDidUpdate() {
    if (this.props.onUpdateHandle) {
      this.props.onUpdateHandle();
    }
  }

  getTabOptions() {
    const { catalogueOptions, webOptions } = this.props;

    // Order matters: catalogue first, web second, matching the slots the old compound markup
    // declared. Either may be absent -- the shelf pages supply only catalogueOptions.
    return [
      { id: 'catalog-item-tab', options: catalogueOptions },
      { id: 'web-item-tab', options: webOptions }
    ]
      .filter(({ options }) => options !== undefined)
      .map(({ id, options }) => ({
        // Mirrors the `testId` Glue's TabContent rendered, so any QA locator keeps working.
        dataTestId: `add-${id}`,
        id,
        label: options.tabName,
        renderPanelBody: () => this.renderPanel(options)
      }));
  }

  renderPanel(options) {
    const { handleSearch, handleClear, handleQueryChange, renderResults, searchLabel, query } = options;

    return (
      <>
        <SearchBar
          query={query}
          label={searchLabel}
          handleSearch={handleSearch}
          handleClear={handleClear}
          handleChange={handleQueryChange}
          isWrappedInForm={this.props.isWrappedInForm === undefined ? true : this.props.isWrappedInForm}
        />
        {this.renderProgressBar()}
        {renderResults()}
      </>
    );
  }

  renderProgressBar() {
    return (
      <div className="progress-bar-wrapper">
        <ProgressBar active={this.props.searching} />
      </div>
    );
  }

  // Glue's tabs rendered no tab strip for a single child, and no callers pass both option sets --
  // AddTitle.jsx supplies catalogueOptions alone -- so the shelf pages have never shown one. Kept
  // in this component rather than in shared/Tabs for the reasons noted on the add-to-list page:
  // suppressing the strip there would dangle the panel's aria-labelledby, and would hide real
  // navigation for its asNav callers.
  renderTabsOrSinglePanel() {
    const { tabsAriaLabel } = this.props;
    const options = this.getTabOptions();

    if (options.length === 0) {
      return null;
    }

    if (options.length === 1) {
      return options[0].renderPanelBody();
    }

    return <Tabs ariaLabel={tabsAriaLabel} options={options} />;
  }

  render() {
    return <section className="cp-add-title">{this.renderTabsOrSinglePanel()}</section>;
  }
}

const tabOptionsShape = PropTypes.shape({
  tabName: PropTypes.string.isRequired,
  searchLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  handleSearch: PropTypes.func.isRequired,
  handleClear: PropTypes.func,
  handleQueryChange: PropTypes.func,
  renderResults: PropTypes.func
});

AddTitle.propTypes = {
  catalogueOptions: tabOptionsShape,
  webOptions: tabOptionsShape,
  searching: PropTypes.bool,
  onUpdateHandle: PropTypes.func,
  isWrappedInForm: PropTypes.bool,
  // Names the tab strip for assistive technology. Only consulted when BOTH option sets are
  // supplied, since one option renders the panel alone with no strip to name.
  tabsAriaLabel: PropTypes.string
};

export default AddTitle;
